import { render } from "./index.vue?vue&type=template&id=f37f3332"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/atoms/heading/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f37f3332"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f37f3332', __exports__)) {
    api.reload('f37f3332', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=f37f3332", () => {
    api.rerender('f37f3332', render)
  })

}


export default __exports__